import { Flex, MantineColor, Text } from '@mantine/core';
import React, { ReactNode } from 'react';
import { ContactItemStyles } from '@dealstack/frontend/shared/components/ContactItem/ContactItem.styles.tsx';

interface Props {
	label: string;
	icon?: ReactNode;
	fw?: 400 | 600;
	color?: MantineColor;
	truncate?: boolean;
}

export const ContactItem = ({
	label,
	icon,
	fw = 400,
	color = 'dark.8',
	truncate = false,
}: Props) => (
	<ContactItemStyles $truncate={truncate}>
		{icon && (
			<Flex align="center" className="icon">
				{icon}
			</Flex>
		)}

		<Text
			p={0}
			fz="sm"
			fw={fw}
			c={color}
			title={truncate ? label : undefined}
			className={truncate ? 'label' : undefined}
		>
			{label}
		</Text>
	</ContactItemStyles>
);
